module.exports = __webpack_public_path__ + "static/media/purchase-orders.71db0a02.svg";